import React from 'react';
import { StyledToggleButtonGroup, StyledToggleButton } from './styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme();

const PKDToggleSwitch = ({ switcher, onChange, disabled }) => {
  return (
    <ThemeProvider
      theme={theme}>
      <StyledToggleButtonGroup
        color='primary'
        value={switcher ?? 'on'}
        exclusive
        onChange={onChange}
        aria-label='Platform'
        disabled={disabled}>
        <StyledToggleButton
          value='on'>On</StyledToggleButton>
        <StyledToggleButton
          value='off'>Off</StyledToggleButton>
      </StyledToggleButtonGroup>
    </ThemeProvider>
  );
};

export default PKDToggleSwitch;
